'use strict';

function dateStringToDate(date) {
  var split = date.split('/');
  var year = +split[2]; //make integer
  if(year < 100){
    year += 2000;
  }
  var month = +split[1] - 1; //make integer and zero indexed
  var day = +split[0]; //make integer
  return new Date(year, month, day);
}

export default class {
	/*@ngInject*/
	constructor($http, JSONToCSVConvertor){
		this.$http = $http;
		this.counts = [];
		this.timesheets = [];
		this.JSONToCSVConvertor = JSONToCSVConvertor;
		this.loadsRequired = 2;
		this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
		this.loaded = false;
	}

	$onInit(){
		this.$http.get('/api/timesheets').then(res => {
			this.timesheets = res.data;

			this.loadsRequired--;
			if(this.loadsRequired === 0){
				this.getCounts();
			};
		})

		this.$http.get('/api/tutors').then(res => {
			this.tutors = res.data;

			this.loadsRequired--;
			if(this.loadsRequired === 0){
				this.getCounts();
			};
		})
	}

	createCSV(){
		this.JSONToCSVConvertor(this.counts, 'Total_Hours_By_State_And_Year', true)
	}

	getState(tutorID){
		const tutor = this.tutors.find(tutor => tutor.tutorID === tutorID);

		if(tutor){
			return tutor.state;
		}

		return 'INVALID';
	}

	getCounts(){
		//add the year and state
		this.timesheets = this.timesheets.map(timesheet => {
			timesheet.year = dateStringToDate(timesheet.weekEnding).getFullYear();
			timesheet.state = this.getState(timesheet.tutorID);

			return timesheet;
		});

		//int year var
		this.years = [];

		//find all year
		this.timesheets.forEach(timesheet => {
			this.years.push(timesheet.year);
		});

		//remove duplicates
		this.years = this.years.filter((item, pos) => {
		    return this.years.indexOf(item) == pos;
		});

		this.years.forEach(year => {
			//find all timesheets that match this year

			const yearSheets = this.timesheets.filter(timesheet => timesheet.year === year);

			this.states.forEach(state => {

				const yearAndState = yearSheets.filter(timesheet => timesheet.state.toLowerCase() === state.toLowerCase())

				if(yearAndState.length){
					this.counts.push({year, state, count: yearAndState.length})
				}
			})
		})
		
		this.loaded = true;
	}
}


// WEBPACK FOOTER //
// ./client/app/reports/total-hours/total-hours.controller.js